import asyncForEachBatch from "./asyncForEachBatch";
import chunkBatch from "./chunkBatch";
import { recordSentry } from "./recordSentry";

/**
 * The table as a whole can handle 40,000 rcu/wcu
 */
const MAX_WRITE_CAPACITY = 200;

/**
 * handles chunking out then creating field instances in batches to the db
 * @param documents The documents to create in dynamodb
 * @param batchCrud The function that makes the actual query using the batch resolver
 * @returns true or an error
 */
export async function handleBatchCrud<T>(documents: T[], batchCrud: (documents: T[]) => Promise<any>, maxItems: number) {
	try {
		if (documents.length > 0) {
			if (documents.length <= maxItems) {
				return await batchCrud(documents);
			} else {
				// Get an array of arrays, where each subarray contains 25 docs
				const docChunks = chunkBatch(documents, maxItems);
				if (docChunks.length < MAX_WRITE_CAPACITY / maxItems) {
					return await asyncForEachBatch(docChunks, batchCrud);
				} else {
					const chunkedChunks = chunkBatch(docChunks, MAX_WRITE_CAPACITY / maxItems);
					const results = [];
					for (const chunk of chunkedChunks) {
						const resultingData = await asyncForEachBatch(chunk, batchCrud);
						for (const result of resultingData) {
							results.push(result);
						}
					}
					return results;
				}
			}
		}
	} catch (err) {
		recordSentry({ error: err, msg: "Error doing batch crud: " });
	}
	return [];
}
